import { createSelector } from "reselect";
import { IAppState } from "../types/stores/index";
import { getFlowExportsForSelectedFlow, getFlowExportsArray } from "./flowExports";
import type { FlowErrorsByItemId, FlowExport } from "../types/stores/flowTypes";
import { Destination } from "../types/types";

export const validateSAATemplateFields = (flowExport: FlowExport, destinations: Array<Destination>): Array<string> => {
    const errors: Array<string> = [];

    if (!destinations?.length) {
        return errors;
    }

    const destination = destinations.find(x => x.PartnerAccessId === flowExport.DestinationId);
    if (!destination) {
        return errors;
    }

    if (destination.SAADeploySetting != 0 && destination.SAADeploySetting != null) {
        if (!flowExport.ActivationChannelId) {
            errors.push("Activation Channel must be selected before calculating.");
        }

        if (!flowExport.DeliveryTypeId) {
            errors.push("Activation Template must be selected before calculating.");
        }
    }

    return errors;
};

// Generates a mapping of flow item IDs to validation errors.
const generateErrorsById = (flowExports: Array<FlowExport>, destinations: Array<Destination>): FlowErrorsByItemId =>
    flowExports.reduce(
        (errorsById, flowExport) => ({
            ...errorsById,
            [flowExport.FlowItemId]: validateSAATemplateFields(flowExport, destinations),
        }),
        {} as FlowErrorsByItemId
    );

export const getExportSAATemplateTypeErrorsForSelectedFlow = createSelector(
    (state: IAppState) => getFlowExportsForSelectedFlow(state),
    (state: IAppState) => state.vars.destinations || [],
    generateErrorsById
);

export const getExportSAATemplateTypeErrorsForAllFlows = createSelector(
    (state: IAppState) => getFlowExportsArray(state),
    (state: IAppState) => state.vars.destinations || [],
    generateErrorsById
);
